import React from "react";
import { ExternalLink, BookOpen, CalendarCheck, Tag, Sparkles } from "lucide-react";

// Small "who we are + where to buy more" card for the Home hub. Beta testers
// asked for a spot that explains why the tracker exists and links out to the
// coaching plans, book and discount codes.
const LINKS = [
  {
    key: "plans",
    icon: CalendarCheck,
    title: "Training plans",
    desc: "Race-ready plans built by SPC coaches — 5K to full-distance triathlon",
    href: "https://www.smartperformancecoaching.co.uk/trainingplans",
    accent: "#E2E30A",
  },
  {
    key: "coaching",
    icon: BookOpen,
    title: "Coaching",
    desc: "1-to-1 coaching packages — training, fuelling and race-day support",
    href: "https://www.smartperformancecoaching.co.uk/coachingpackages",
    accent: "#4C9AFF",
  },
  {
    key: "club",
    icon: Tag,
    title: "SPC Club",
    desc: "Athlete perks, discounts and community — join the club",
    href: "https://www.smartperformancecoaching.co.uk/club",
    accent: "#34C759",
  },
];

export default function AboutSPC() {
  return (
    <section data-testid="about-spc" className="mt-10 border border-white/10 bg-[#141414] p-6 sm:p-8">
      <div className="flex items-start gap-4 flex-wrap">
        <div className="inline-flex items-center justify-center h-12 w-12 border border-[#E2E30A]/40 bg-[#E2E30A]/10 shrink-0">
          <Sparkles className="h-5 w-5 text-[#E2E30A]" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#E2E30A]">About Smart Performance</p>
          <h2 className="font-display text-2xl sm:text-3xl uppercase tracking-tight mt-1 leading-tight">Why use this tracker?</h2>
          <p className="text-sm text-zinc-300 mt-3 leading-relaxed max-w-2xl">
            Most food trackers guess your calories from a spreadsheet. This one is built for endurance athletes — it
            reads your training, matches your fuelling to each session, and shows you the exact grammage,
            the fuelling signals your coach cares about. Faster recoveries, fewer bonks, no under-fuelling.
          </p>
        </div>
      </div>

      <div className="grid sm:grid-cols-3 gap-3 mt-6" data-testid="spc-links">
        {LINKS.map((l) => (
          <a key={l.key} data-testid={`spc-link-${l.key}`} href={l.href} target="_blank" rel="noopener noreferrer"
            className="group flex flex-col border border-white/10 bg-[#0A0A0A] p-4 hover:border-white/30 hover:bg-white/[0.03] transition-colors">
            <span className="inline-flex items-center justify-center h-9 w-9 shrink-0" style={{ backgroundColor: l.accent }}>
              <l.icon className="h-4 w-4 text-black" />
            </span>
            <span className="font-display text-lg uppercase tracking-tight mt-3">{l.title}</span>
            <span className="text-xs text-zinc-400 mt-1 flex-1">{l.desc}</span>
            <span className="inline-flex items-center gap-1 text-[11px] uppercase tracking-wider mt-3" style={{ color: l.accent }}>
              Open <ExternalLink className="h-3 w-3 group-hover:translate-x-0.5 transition-transform" />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
